// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';

export const STORE_COPY = {
	title: msg({
		message: 'Store',
		context: 'store',
		comment: 'Store page title and sidebar label.',
	}),
	subtitle: msg({
		message: 'Make your profile yours. Items you buy stay yours forever.',
		context: 'store',
		comment: 'Store page subtitle.',
	}),
	tabNameplates: msg({
		message: 'Nameplates',
		context: 'store',
		comment: 'Store tab for nameplates.',
	}),
	tabHome: msg({
		message: 'Featured',
		context: 'store',
		comment: 'Store tab: the featured front page with collections.',
	}),
	tabProfileEffects: msg({
		message: 'Profile effects',
		context: 'store',
		comment: 'Store tab for animated profile card effects.',
	}),
	tabDecorations: msg({
		message: 'Avatar decorations',
		context: 'store',
		comment: 'Store tab for avatar decorations.',
	}),
	proIncluded: msg({
		message: 'Included with {premiumProductName}',
		context: 'store',
		comment: 'Badge on items that come with the premium membership.',
	}),
	owned: msg({
		message: 'Owned',
		context: 'store',
		comment: 'Badge on items the user bought.',
	}),
	equipped: msg({
		message: 'Equipped',
		context: 'store',
		comment: 'Button label on the item the user is wearing.',
	}),
	equip: msg({
		message: 'Use',
		context: 'store',
		comment: 'Button that equips an owned item.',
	}),
	buy: msg({
		message: 'Buy',
		context: 'store',
		comment: 'Button that starts buying a store item.',
	}),
	getPro: msg({
		message: 'Get {premiumProductName}',
		context: 'store',
		comment: 'Button on premium-included items for users without premium.',
	}),
	comingSoon: msg({
		message: 'Coming soon',
		context: 'store',
		comment: 'Shown on items that are not on sale yet.',
	}),
	loadFailed: msg({
		message: 'The store could not be loaded. Please try again.',
		context: 'store',
		comment: 'Store load error.',
	}),
	empty: msg({
		message: 'There are no items here yet.',
		context: 'store',
		comment: 'Empty state of a store tab.',
	}),
	purchaseSuccessTitle: msg({
		message: 'Added to your collection!',
		context: 'store',
		comment: 'Payment dialog success title for a store item.',
	}),
	purchaseSuccessBody: msg({
		message: 'You can start using it right away.',
		context: 'store',
		comment: 'Payment dialog success text for a store item.',
	}),
	inStore: msg({
		message: 'In the store',
		context: 'store',
		comment: 'Label on locked items in the profile pickers.',
	}),
	previewName: msg({
		message: 'Your name',
		context: 'store',
		comment: 'Fallback preview label when the user has no display name.',
	}),
} as const;
